import { ColumnFilter } from "./ColumnFilter";

export const COLUMNS = [
  {
    Header: `Buyer/Seller`,
    accessor: "buyer_seller",
  },
  {
    Header: "Date",
    accessor: "date",

    disableFilters: true,
  },

  // {
  //   Header: "Currency",
  //   accessor: "currency",
  // },
  {
    Header: "Amount",
    accessor: "amount",
  },
  {
    Header: "Rate",
    accessor: "rate",
  },
  {
    Header: "Payment Method",
    accessor: "payment",
  },
  {
    Header: "Action",
    accessor: "action",

    disableSorting: true,
  },
];
export const dashboadBuyandSellcolumns = [
  {
    Header: `Buyer/Seller`,
    accessor: "buyer_seller",
  },
  {
    Header: "Date",
    accessor: "date",

    disableFilters: true,
  },

  // {
  //   Header: "Currency",
  //   accessor: "currency",
  // },
  {
    Header: "Amount",
    accessor: "amount",
  },
  {
    Header: "Rate",
    accessor: "rate",
  },
  {
    Header: "Offer type",
    accessor: "offertype",
  },
  {
    Header: "Action",
    accessor: "action",

    disableSorting: true,
  },
];
